import { graphql } from '@generated/gql';

/**
 * Prefixed with the hook it belongs to, because several other documents
 * already query `fetchAssetClasses` and operation names are global. This one
 * asks only for what identifies an asset class.
 */
export const FETCH_ASSET_CLASS_COLOR_REGISTRY = graphql(/** GraphQL */ `
  query useAssetClassColorsFetchRegistry($input: FetchAssetClassesInput) {
    fetchAssetClasses(input: $input) {
      assetClasses {
        id
        key
        name
      }
    }
  }
`);
